import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Modal } from "ui";

import { usePayEarnings } from "../../../apis";
import { PayEarningsModalProps } from "./PayEarningsModal.types";

import styles from "./PayEarningsModal.module.scss";

const PayEarningsModal = ({
  earningIds,
  isOpen,
  onClose,
  onSuccess
}: PayEarningsModalProps) => {
  const { t } = useTranslation();

  const isMultiple = Array.isArray(earningIds);

  const { mutate: payEarnings, isLoading } = usePayEarnings({
    onSuccess: () => {
      toast.success(
        isMultiple
          ? t("Selected earnings paid successfully")
          : t("Earning paid successfully")
      );
      onSuccess?.();
      onClose?.();
    }
  });

  return (
    <Modal
      isOpen={isOpen}
      title={isMultiple ? t("Pay Earnings") : t("Pay Earning")}
      okText="Confirm"
      isLoading={isLoading}
      onOk={() => {
        payEarnings({ earningIds: isMultiple ? earningIds : [earningIds] });
      }}
      contentClassName={styles.payEarningsModal}
      onClose={onClose}
    >
      <p className={styles.payEarningsModal_text}>
        {isMultiple
          ? t("Are you sure you want to pay selected earnings?")
          : t("Are you sure you want to pay the earning?")}
      </p>
    </Modal>
  );
};

export default PayEarningsModal;
